import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { TrafficsDtoKeysEnum } from '@zaoblako/shared/modules/traffic/enums/traffics-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SensorFormDto, type SensorFormInterface } from '@zaoblako/shared/modules/traffic/dtos/sensor/sensor-form.dto';
import { AdapterTypeEnum } from '@zaoblako/shared/modules/traffic/enums/adapter.type.enum';
import { AdapterTypeEnumI18n } from '@zaoblako/shared/modules/traffic/i18n/adapter-type-enum.i18n'
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';

import * as yup from 'yup';

/** Adapter create/update request body */
export interface AdapterFormInterface {
  /** Adapter display name */
  name: string;
  /** Adapter MAC-address */
  mac?: string;
  /** Adapter IP-address */
  ipAddress?: string;
  /** Adapter room */
  room?: RoomFindInterface;
  /** Adapter type */
  type: AdapterTypeEnum;
  /** Adapter sensors */
  sensors?: SensorFormInterface[];
}

/** Adapter create/update request body - DTO schema */
export const AdapterFormDto = SerdeDtoClass.create<AdapterFormInterface>(TrafficsDtoKeysEnum.ADAPTER_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  mac: {
    optional: true,
    label: 'MAC-адрес',
    serializer: yup
      .string()
      .matches(
        /^([0-9a-fA-F]{2}:){5}([0-9a-fA-F]{2})$/,
        'Некорректный MAC-адрес',
      ),
  },
  ipAddress: {
    optional: true,
    label: 'IP-адрес',
    serializer: yup.string(),
  },
  type: {
    label: 'Тип',
    serializer: commonEnumValidator(AdapterTypeEnum, AdapterTypeEnumI18n),
  },
  room: {
    optional: true,
    label: 'Помещение',
    serializer: entityLikeSchema,
  },
  sensors: {
    optional: true,
    label: 'Сенсоры',
    nested: SensorFormDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
